export default __webpack_public_path__ + "static/media/human-sitting.732f4422.svg";